import Utils from './utilities'

const WINDOW_VARS: any = {}

export interface windowRef {
    nativeWindow: any
}

export const WINDOW: windowRef = {
    nativeWindow: (window || {}) as any
}

export const sendEvent = (eventName: string) => {
    let event

    if (typeof(Event) === 'function') {
        event = new CustomEvent(eventName)
    } else {
        event = window.document.createEvent('Event')
        event.initEvent(eventName, true, true)
    }

    window.dispatchEvent(event)
}

export const getHotlistId: Function = (): string => {
    if (!Utils.isDefined(WINDOW_VARS.hotlistID)) {
        WINDOW_VARS.hotlistID = window.location.pathname
            .replace(/\/hotlist\//g, '')
            .replace('/', '')
    }

    return WINDOW_VARS.hotlistID
}